export default __webpack_public_path__ + "static/media/notification_promo_icon.b577fd7a.svg";